import { useEffect, useState } from 'react';

export const useSidebarSetSize = (breakpoint = 1550) => {
  const [isSmallSize, setIsSmallSize] = useState(() => window.innerWidth < breakpoint);

  useEffect(() => {
    const handler = () => setIsSmallSize(window.innerWidth < breakpoint);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [breakpoint]);

  return isSmallSize;
};
